import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { equals, is, update, remove } from 'ramda'
// import interact from 'interactjs'
import wrapper from './AreaCropWrapper'

import { DeleteIcon, NumberIcon } from './Icons'
class AreaCrop extends Component {
  constructor(props) {
    super(props);
    this.coordinate = _.cloneDeep(this.props.coordinate);
  }
  getAreaCropStyle(coordinate) {

    let obj = {
      // border: '1px dotted rgba(153,153,153,1)',
      // background: 'rgba(153,153,153,0.3)',
      display: 'inline-block',
      position: 'absolute',
      width: coordinate.width,
      height: coordinate.height,
      top: coordinate.y,
      left: coordinate.x,
      boxShadow: '0 0 6px #000',
      background: '#8c8c8c',
      // opacity: (this.props.bSelected ? 0.9 : 0.6),
    }
    return obj;
  }
  getClassName(str) {
    let className = "AreaCrop_" + str;
    if (!!this.props.extendClassName) {
      className = className + " " + this.props.extendClassName + "AreaCrop_" + str
    }
    return className;
  }
  componentDidMount() {
    if (!this.props.isReadOnly) {
      wrapper(this.areaCrop)
        .draggable({})
        .resizable({
          edges: {
            left: true, right: true, bottom: true, top: true,
          },
        })
        .on('dragmove', this.handleDragMove)
        .on('resizemove', this.handleResizeMove)
      //.on('doubletap', this.handleDoubleTap)
    }
  }
  shouldComponentUpdate(nextProps) {
    // reduce uncessary update
    // return !equals(nextProps.coordinate, this.props.coordinate)
    //   || (nextProps.index !== this.props.index);

    let bFlag = (
      _.isEqual(nextProps.coordinate, this.coordinate) == false
      || (nextProps.index !== this.props.index)
      || (nextProps.bSelected !== this.props.bSelected)
    )
    if (bFlag) {
      this.coordinate = _.cloneDeep(nextProps.coordinate);
    }
    return bFlag;
  }

  handleResizeMove = (e) => {
    const {
      index,
      coordinate,
      coordinate: { x, y },
      coordinates,
      onResize,
      onChange,
    } = this.props
    const { width, height } = e.rect
    const { left, top } = e.deltaRect

    const nextCoordinate = {
      ...coordinate, x: x + left, y: y + top, width, height,
    }
    const nextCoordinates = update(index, nextCoordinate)(coordinates)
    if (is(Function, onResize)) {
      onResize(nextCoordinate, index, nextCoordinates)
    }
    if (is(Function, onChange)) {
      onChange(nextCoordinate, index, nextCoordinates)
    }
  }
  handleDragMove = (e) => {
    const {
      index,
      coordinate,
      coordinate: { x, y },
      coordinates,
      onDrag,
      onChange,
    } = this.props
    const { dx, dy } = e
    const nextCoordinate = { ...coordinate, x: x + dx, y: y + dy }
    const nextCoordinates = update(index, nextCoordinate)(coordinates)
    if (is(Function, onDrag)) {
      onDrag(nextCoordinate, index, nextCoordinates)
    }

    if (is(Function, onChange)) {
      onChange(nextCoordinate, index, nextCoordinates)
    }
  }

  handleDelete = () => {
    const {
      index,
      coordinate,
      onDelete,
      coordinates,
    } = this.props
    const nextCoordinates = remove(index, 1)(coordinates)
    if (is(Function, onDelete)) {
      onDelete(coordinate, index, nextCoordinates)
    }
  }

  componentWillUnmount() {
    if (!this.props.isReadOnly) {
      wrapper(this.areaCrop)
        .unset()
    }
  }


  render() {
    const { coordinate, index } = this.props
    if (!coordinate.refResetFields)
      coordinate.refResetFields = {};
    let params = { coordinate, areaHtml: undefined };
    let CaptionEle;
    if (this.props.doFunc) {
      this.props.doFunc("getHotAreaCaptionHtml", params)
    }
    if (params.areaHtml) {
      CaptionEle = <div
        className={this.getClassName("Caption")}
        dangerouslySetInnerHTML={{ __html: params.areaHtml }}
      >
      </div>;
    }
    else {
      CaptionEle = <div className={this.getClassName("Caption")} >
        <div className={this.getClassName("Caption_1")} >
          {coordinate.code || ""}
        </div>
        <div className={this.getClassName("Caption_2")}>
          {coordinate.name || ""}
        </div>
      </div>;
    }

    return (
      <div
        className={this.getClassName("Inner")}
        style={this.getAreaCropStyle(coordinate)}
        ref={crop => this.areaCrop = crop}
      >
        {this.props.isReadOnly ? "" : <DeleteIcon
          onClick={this.handleDelete}
        />}
        {CaptionEle}
      </div>
    )
  }
}


export const coordinateType = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
})

AreaCrop.propTypes = {
  coordinate: coordinateType.isRequired,
  index: PropTypes.number.isRequired,
  onResize: PropTypes.func, // eslint-disable-line
  onDrag: PropTypes.func, // eslint-disable-line
  onDelete: PropTypes.func, // eslint-disable-line
  onChange: PropTypes.func, // eslint-disable-line
  coordinates: PropTypes.array // eslint-disable-line
}

export default AreaCrop



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/HotArea/components/AreaCrop.js